import Http from "./Http";

export class ConsentFormsService extends Http {
  /**
   * Create consent form
   * @param {Object} body
   */
  createConsentForm(body) {
    return this.post(`/consent-forms`, body);
  }

  /**
   * Get consent forms
   * @param {Object} params
   */
  getConsentForms(params) {
    return this.get(`/consent-forms`, { params });
  }

  /**
   * Delete consent form
   * @param {String} id
   */
  deleteConsentForm(id) {
    return this.delete(`/consent-forms/${id}`);
  }

  /**
   * Edit consent form name
   * @param {String} id
   * @param {String} formName
   */
  editConsentFormName(id, formName) {
    return this.put(`/consent-forms/${id}/form-name`, { formName });
  }

  /**
   * Download consent form template
   */
  getConsentFormTemplateLink() {
    return this.get(`/consent-forms/link`);
  }
  /**
   * Update status
   */
  updateStatus({ body, id }) {
    return this.put(`/consent-forms/${id}/status`, body);
  }

  /**
   * Assign form
   */
  assignForm(body) {
    return this.put(`/consent-forms/assign`, body);
  }

  /**
   * Create consent form link
   */
  createConsentFormLink(body) {
    return this.post(`/consent-forms/links`, body);
  }

  /**
   * Get new sign consent forms count
   */
  getNewSignConsentFormsCount() {
    return this.get(`/consent-forms/counters`);
  }
}

ConsentFormsService.$displayName = "ConsentFormsService";

export default new ConsentFormsService();
